<ion-card>
    <ion-card-header *ngIf="showHeader">
        <ion-label>{{'Phone' | translate}}</ion-label>
    </ion-card-header>
    <ion-card-content>
      <adress-detail *ngIf="phonePanelProvider.addressData.firstname" [address]="phonePanelProvider.addressData"></adress-detail>
      <form [formGroup]="callForm">
        
          <ion-item>
            <ion-label color="primary" position="stacked">{{'Comment' | translate}}</ion-label>
            <ion-textarea name="comment" formControlName="comment" [placeholder]="'CommentCallPlaceholder' | translate"></ion-textarea>
          </ion-item>

        <ion-item>
          <ion-label position="stacked">{{'Event' | translate}}</ion-label>
          <ion-select formControlName="callResult" (ngModelChange)="changeCallResult()">
            <ion-select-option [value]="'CallEvent.DoctorCall' | translate">{{'CallEvent.DoctorCall' | translate}}</ion-select-option>
            <ion-select-option [value]="'CallEvent.MemberCall' | translate">{{'CallEvent.MemberCall' | translate}}</ion-select-option>
            <ion-select-option [value]="'CallEvent.ReferencePersonCall' | translate">{{'CallEvent.ReferencePersonCall' | translate}}</ion-select-option>
            <ion-select-option [value]="'CallEvent.PatientCall' | translate">{{'CallEvent.PatientCall' | translate}}</ion-select-option>
            <ion-select-option [value]="'CallEvent.Other' | translate">{{'CallEvent.Other' | translate}}</ion-select-option>
            <ion-select-option [value]="'CallEvent.TestCall' | translate">{{'CallEvent.TestCall' | translate}}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item>
          <ion-button [disabled]="!phonePanelProvider.phoneData.phoneNumber" (click)="initiateCall()" size="large" expand="block">
            <ion-icon slot="start" name="call"></ion-icon>
            {{phonePanelProvider.phoneData.phoneNumber}}<br *ngIf="phonePanelProvider.phoneData.phoneNumber" />
            {{'Call' | translate}}
          </ion-button>
        </ion-item>
      </form>
    </ion-card-content>
</ion-card>


